import { List } from 'immutable';

export const apiBaseUrlSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'api']);
export const authApiUrlSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'authApi']);
export const recalcApiUrlSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'recalcApi']);
export const appealApiUrlSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'appealApi']);
export const deedApiUrlSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'deedApi']);
export const appraisalNoticeApiUrlSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'appraisalNoticeApi']);
export const urlsSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls']);
export const serviceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service']);
export const appealsServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'appealsService']);
export const publicServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'publicService']);
export const userServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'userService']);
export const taxingUnitServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'taxingUnitService',
  ]);
export const taxTransparencyServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'taxTransparencyService',
  ]);
export const recalculationServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'recalculationService',
  ]);
export const microsoftServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'microsoftService',
  ]);
export const virtualHelpServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'virtualHelpService',
  ]);
export const conferenceServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'conferenceService',
  ]);
export const deedServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'deedService']);
export const sketchServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'sketchService']);
export const appraisalServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'appraisalService',
  ]);
export const importServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'importService']);
export const appraisalServicePerOfficeSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'appraisalServicePerOffice',
  ]);
export const assessmentServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'assessmentService',
  ]);
export const equityfinderServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'equityfinderService',
  ]);
export const eventServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'eventService']);
export const gamaServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'gamaService']);
export const hsAuditServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'hsAuditService']);
export const litigationServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'litigationService',
  ]);
export const mraServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'mraService']);
export const appraisalNoticeServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'appraisalNoticeService',
  ]);
export const reportServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'reportService']);
export const s3ServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 's3Service']);
export const queueServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'queueService']);
export const integrityServiceSelector = (state) =>
  state.getIn([
    'app',
    'global',
    'configuration',
    'service',
    'integrityService',
  ]);
export const mobileServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'mobileService']);
export const ptdServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'ptdService']);
export const exportServiceSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'service', 'exportService']);
export const getUserRights = (state) =>
  state.getIn(['app', 'global', 'user', 'userrights'], List([]));
export const authenticationTokenSelector = (state) =>
  state.getIn(['app', 'global', 'user', 'token']);
export const googleMapAPIKeySelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'keys', 'googleMapAPIKey']);
export const clientIdSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'keys', 'clientID']);

export const userDataSelector = (state) =>
  state.getIn(['app', 'global', 'user']);

export const userRightsSelector = (state) =>
  state.getIn(['app', 'global', 'user', 'userrights']);

export const userEmailSelector = (state) =>
  state.getIn(['app', 'global', 'user', 'email']);

export const officeDataSelector = (state) =>
  state.getIn(['app', 'global', 'user', 'office']);

export const userModuleSelector = (state) =>
  state.getIn(['app', 'global', 'user', 'modules']);
export const isSidebarVisibleSelector = (state) =>
  state.getIn(['app', 'global', 'isSidebarVisible']);
export const isPageMenuVisibleSelector = (state) =>
  state.getIn(['app', 'global', 'isPageMenuVisible']);
export const isRecordingStartSelector = (state) =>
  state.getIn(['app', 'global', 'isRecordingStart']);
export const officesSelector = (state) =>
  state.getIn(['app', 'global', 'offices']);
export const usersSelector = (state) => state.getIn(['app', 'global', 'users']);
export const versionSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'version']);
export const lastRecalcStatusSelector = (state) =>
  state.getIn(['app', 'global', 'lastRecalcStatus']).toJS();
export const userStatusSelector = (state) =>
  state.getIn(['app', 'global', 'userStatus']);
export const routeStateSelector = (state, key) => {
  const routeStateData = state.getIn(['app', 'global', 'routeState', key]);
  return routeStateData ? routeStateData.routeState : null;
};
